<template>
	<div class="" :class="[bgColorPaymentDetail ? 'bg-paymentBlue' : '', isScroll ? 'h-full': 'noScroll']">
		<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="false"
			staticMode="true"
		>
		</TopAppBar>
		<div class="d-flex flex-column h-full" :class="wHeight" id="getId">
			<!-- <TopAppBarDrawer></TopAppBarDrawer> -->
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
/**
 * 마이페이지 메인 컴포넌트(mypage main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../mixins/topAppBar.js'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";

export default {
	name: '',

	components: {
		TopAppBar,
		TopAppBarDrawer
	},

	mixins: [topAppBarMixin],

	data() {
		return {
			title: localStorage.getItem('brandName'),
			screenSize: "",
			innerHeight: "",
			heightFix: 0,
			contentHeight: 0,
			wHeight: 0,
			bgColorPaymentDetail: false,
			isScroll: false,
			noScroll:false
		}
	},

	created() {
    window.addEventListener("scroll", this.myEventHandler);
	},

	destroyed() {
		window.removeEventListener("scroll", this.myEventHandler);
	},

	updated() {
	},

	mounted(){
		document.body.classList.remove('mdc-dialog-scroll-lock')
		this.$nextTick(function(){
			window.addEventListener('resize', this.heightAdjust);
		})
		if ($(document).height() < $(window).height()) {
      		this.isScroll = true;
		}
		if ($(document).height() == $(window).height()) {
      		this.noScroll = true;
		}
	},

	watch: {
		'$route': {
		   handler: function(to, from) {
			   this.bgColorPaymentDetail = false
			   window.addEventListener('resize', this.heightAdjust);
				if (to.name === 'MemberProfilePatten' || to.name === 'MemberProfilePicture') {
					// this.setTopAppBarBackOnly('')
					this.leftBtnMode = 'close'
					this.leftBtnMethod = () => {
						document.body.classList.remove('mdc-dialog-scroll-lock')
						this.$router.go(-1)
					}
				} else if(to.name === 'MyInformation') {
					let learnBack=localStorage.getItem("goToSetting")
					if(learnBack === 'setting') {
						localStorage.removeItem("goToSetting");
						this.leftBtnMode = 'arrow_back'
						this.rightBtnMode = ''
						this.title = localStorage.getItem('brandName')
						this.leftBtnMethod = () => {
							this.$router.push({
								name: "setting",
							})
						}
					} else {
						this.leftBtnMode = 'menu'
						this.rightBtnMode = 'search'
						this.title = localStorage.getItem('brandName')
						this.leftBtnMethod = () => {
						}
					}
					this.rightBtnMethod = ''
				} else if(to.name === 'MemberDetail') {
					//this.setTopAppBarBackOnly(this.$t('1746'))
					this.leftBtnMode = 'arrow_back'
					this.rightBtnMode = ''
					this.title = localStorage.getItem('brandName')
					this.leftBtnMethod = () => {
						this.$router.push({
							name: "MyInformation",
						})
					}
					this.rightBtnMethod = ''
				} else if(to.name === 'MemberPhoneNo') {
					this.setTopAppBarHomeSearch(localStorage.getItem('brandName'))
				} else if(to.name === 'MemberDOB') {
					this.setTopAppBarHomeSearch(localStorage.getItem('brandName'))
				} else if(to.name === 'MemberPurchase') {
					this.setTopAppBarHomeSearch(localStorage.getItem('brandName'))
				} else if(to.name === 'MemberPurchaseRefundView') {
					this.bgColorPaymentDetail = true
					this.setTopAppBarHomeSearch(localStorage.getItem('brandName'))
				} else if(to.name === 'MemberPurchaseView') {
					this.bgColorPaymentDetail = true
					this.setTopAppBarHomeSearch(localStorage.getItem('brandName'))
				} else {
					this.bgColorPaymentDetail = false
					this.setTopAppBarHomeSearch(localStorage.getItem('brandName'))
				}
			},
			deep: true,
			immediate: true,
		}
	},

	methods:{
		heightAdjust(event) {
			let sh = document.getElementById('getId').scrollHeight;
			if(window.innerHeight >sh){
				this.wHeight = 'h-full'
			} else {
				this.wHeight = 'h-full bg-paymentBlue'
			}
		},

		setTopAppBarHomeSearch(title) {
			this.leftBtnMode = 'arrow_back'
			this.rightBtnMode = ''
			this.title = title
			this.leftBtnMethod = () => {
				this.$router.go(-1)
			}
			this.rightBtnMethod = ''
		}
	},

	beforeDestroy() {
		window.removeEventListener('resize', this.heightAdjust);
	}
}
</script>

<style scoped>
.material-icons.blue0006 { color: var(--Primary); }
/* .noScroll{
	height: calc(100% - 118px);
} */
</style>
